// extracted by extract-css-chunks-webpack-plugin
module.exports = {"gridContainer":"YD8oh","cardContainer":"_7snyb"};